import React, { useState } from "react";
import { Dialog, TextField, InputAdornment } from '@mui/material';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import colors from "../../../../../colors";
import { texts } from "../../../../../general/texts";
import SearchIcon from "@mui/icons-material/Search";

const IncludedCountries = ({ isDialogOpened, handleClose, countries }) => {
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const [searchTerm, setSearchTerm] = useState("");

    const filteredCountries = countries.filter((country) =>
        country.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Dialog
            open={isDialogOpened}
            onClose={handleClose}
            keepMounted
            fullWidth
            maxWidth="lg"
            PaperProps={{
                style: {
                    borderRadius: '20px',
                    width: '500px',
                    height: 'auto',
                    padding: isSmallScreen ? '15px' : '35px',
                    zIndex: 888,
                    background: colors.white
                },
            }}
        >
            <div>
                <p style={{
                    textAlign: 'start',
                    fontSize: '30px',
                    fontFamily: 'GerberaBold',
                    color: colors.orange,
                    margin: '0 0 12px 0'
                }}>
                    {texts['prompt-included-countries']}
                </p>
                <div style={{
                    textAlign: 'start',
                    fontSize: '18px',
                    fontFamily: 'GerberaMedium',
                    color: colors.darkBlue,
                    margin: '0 0 15px 0',
                }}>
                    Ne kete pakete perfshihen {countries.length} shtete:
                </div>
                <TextField
                    fullWidth
                    variant="outlined"
                    color="warning"
                    placeholder="Kërko"
                    value={searchTerm}
                    size="small"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon style={{ color: colors.orange }} />
                            </InputAdornment>
                        ),
                    }}
                    style={{
                        marginBottom: '15px',
                        borderRadius: '10px'
                    }}
                />
                <div style={{
                    maxHeight: isSmallScreen ? '60vh' : '500px',
                    overflowY: 'auto',
                    padding: '5px',
                    border: `1px solid ${colors.lightGray}`,
                    borderRadius: '10px'
                }}>
                    {filteredCountries.length > 0 ? (
                        filteredCountries.map((country, index) => (
                            <div key={index} style={{ margin: '5px 0', color: colors.darkBlue }}>{country}</div>
                        ))
                    ) : (
                        <div style={{ color: colors.darkBlue, textAlign: 'left', marginTop: '10px' }}>
                            {texts['message-no-country-found']}
                        </div>
                    )}
                </div>
            </div>
        </Dialog>
    );
}

export default IncludedCountries;
